import { Typography } from "@bonusx-global/bx-design-system";
import { GREET_TEXT } from "../../../../constants/commonStrings";
import { useFormValues } from "../../../hooks/useFormValues";
import { CHATBOT_NAME } from "../../../../features/ai-chatbot/constants/chatbot-name.const";
import Emoji from "../../common/Emoji";

export const AI_CHATBOT_SUGGESTIONS_TEXT = "Ecco alcuni suggerimenti per iniziare:";
const I_AM_TEXT = "Sono";
const YOUR_VIRTUAL_AI_TEXT = "il tuo assistente virtuale";

function AiChatbotSuggestedPromptChatHeader(): JSX.Element {
  const { Nome } = useFormValues();

  return (
    <div>
      <Typography variant="body1">
        {GREET_TEXT} {Nome}!
      </Typography>
      <Typography variant="body1">
        {I_AM_TEXT} {CHATBOT_NAME}, {YOUR_VIRTUAL_AI_TEXT} <Emoji ariaLabel="smile" emojiSymbol="😊" />
      </Typography>
      <Typography variant="body1">{AI_CHATBOT_SUGGESTIONS_TEXT}</Typography>
    </div>
  );
}

export default AiChatbotSuggestedPromptChatHeader;
